"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;

var _Provider = _interopRequireWildcard(require("./components/Provider"));

exports.Provider = _Provider.default;
exports.createProvider = _Provider.createProvider;

var _connectAdvanced = _interopRequireDefault(require("./components/connectAdvanced"));

exports.connectAdvanced = _connectAdvanced.default;

var _connect = _interopRequireDefault(require("./connect/connect"));

exports.connect = _connect.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/lib/index.js
// module id = 18
// module chunks = 0